import { apiFetch } from "@/lib/api";

export interface ManufacturingInternalLaborMonthRate {
  yearMonth: string;
  laborDollarsPerHour: number;
  overheadDollarsPerHour: number;
}

export interface ManufacturingHubSettingsPayload {
  ratesByMonth: ManufacturingInternalLaborMonthRate[];
}

export type ManufacturingHubSettingsResponse = ManufacturingHubSettingsPayload & {
  updatedAt: string | null;
};

export const MANUFACTURING_HUB_SETTINGS_QUERY_KEY = ["manufacturing", "hub-settings"] as const;

export async function fetchManufacturingHubSettings(): Promise<ManufacturingHubSettingsResponse> {
  return apiFetch<ManufacturingHubSettingsResponse>("/api/manufacturing/settings", {
    cache: "no-store",
  });
}

export async function patchManufacturingHubSettings(
  patch: Partial<ManufacturingHubSettingsPayload>,
): Promise<ManufacturingHubSettingsResponse> {
  return apiFetch<ManufacturingHubSettingsResponse>("/api/manufacturing/settings", {
    method: "PATCH",
    body: patch,
  });
}
